/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenMonitorIcon16Solid = forwardRef('TechScreenMonitorIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12.3 2A2.7 2.7 0 0 1 15 4.7v4.6a2.7 2.7 0 0 1-2.7 2.7H10v1h1a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h1v-1H3.7A2.7 2.7 0 0 1 1 9.3V4.7A2.7 2.7 0 0 1 3.7 2h8.6Z" })));
});
